"use client"

import axios from 'axios';
import AuthStorage from '../storage/AuthStorage';
import crypto from "crypto-js";
import { saveAs } from 'file-saver';


/*
  
para las url externas, hay que manejar los queryparams como base64 con hash
import crypto from "crypto-js";
crypto.SHA512(plain_text).toString()

var encodedStringBtoA = btoa(decodedStringBtoA);
var decodedStringAtoB = atob(encodedStringAtoB);

*/

export class GenericaSistemaService {

    async GetFileBase64(idEmpresa, idioma, userName, urlAsset) {

        console.log("GetFileBase64, ", idEmpresa, idioma, userName, urlAsset);
        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'urlAsset': urlAsset })
        };

        let response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetFileBase64', requestOptions.body);

        return response.data;
    }

    async getMetadataGenericasSistema(tg, idEmpresa, idioma, userName) {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg })
        };

        let response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetMetadataGenericasSistema', requestOptions.body);

        return response.data;
    }

    async getMetadataGenericasConOperacionesDeTg(tg, idEmpresa, idioma, userName) {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg })
        };

        let response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetMetadataGenericasConOperacionesDeTg', requestOptions.body);

        return response.data;
    }

    async GetOptionsSelectButtonDeTg(tg, idEmpresa, idioma, userName, filtroUts) {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts })
        };

        let response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetOptionsSelectButtonDeTg', requestOptions.body);

        return response.data;
    }

    async GetOptionsSelectButtonDeTgFormato(tg, idEmpresa, idioma, userName, filtroUts) {

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts })
        };

        let response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetOptionsSelectButtonDeTgFormato', requestOptions.body);

        return response.data;
    }

    async getTipoGenericaSistemaByMenu(params, idEmpresa, idioma, userName, codMenu) {

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'codMenu': codMenu })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetTipoGenericaSistemaByMenu', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async GetTipoGenericaSistemaByKeys(params, idEmpresa, idioma, userName, keys) {

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'keys': keys })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetTipoGenericaSistemaByKeys', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async GetTipoGenericaSistemaByTg(params, idEmpresa, idioma, userName, tg) {

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetTipoGenericaSistemaByTg', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async getTipoGenericaSistema(params, idEmpresa, idioma, userName) {

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllTipoGenericaSistema', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async getTipoGenericaAsociadas(params, idEmpresa, idioma, userName, tg) {

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllTipoGenericaAsociada', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async GetAllTipoGenericaConOperacionesOfTg(params, idEmpresa, idioma, userName, tg) {

        //console.log("GetAllTipoGenericaConOperacionesOfTg");
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllTipoGenericaConOperacionesOfTg', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async getGenericasSistema(tg, params, idEmpresa, idioma, userName, filtroUts) {

        //console.log("getGenericasSistema1", {tg, params, idEmpresa, idioma, userName, tokenAuth});

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllGenericasSistema?' + queryParams, requestOptions.body);

        const data = response.data;
        let camposDate = data.metadata.filter(x => x.tipoDato.toLowerCase() === "date");

        if (camposDate.length > 0) {
            data.data.forEach(genSistema => {
                camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
            });
        }

        let camposBoolean = data.metadata.filter(x => x.tipoDato.toLowerCase() === "boolean");
        let reqSerializacion = false;

        if (camposBoolean.length > 0 && data.data.length > 0) {

            console.log("data.data, ", data.data);
            let genSistema = data.data[0];
            camposBoolean.forEach(metadata => { reqSerializacion = reqSerializacion || typeof genSistema["uts"][metadata.campo] !== "boolean" });

            if (reqSerializacion) {
                data.data.forEach(genSistema => {
                    camposBoolean.forEach(metadata => { if (typeof genSistema["uts"][metadata.campo] !== "boolean") genSistema["uts"][metadata.campo] = genSistema["uts"][metadata.campo].toLowerCase() === "true" });
                });
            }

        }

        return response.data;
    }

    async getGenericaSistemaWithToken(tg, params, idEmpresa, idioma, userName, filtroUts) {

        //console.log("getGenericasSistema1", {tg, params, idEmpresa, idioma, userName, tokenAuth});

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetGenericaSistemaWithToken?' + queryParams, requestOptions.body);

        const data = response.data;
        let camposDate = data.metadata.filter(x => x.tipoDato.toLowerCase() === "date");

        if (camposDate.length > 0) {
            data.data.forEach(genSistema => {
                camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
            });
        }

        let camposBoolean = data.metadata.filter(x => x.tipoDato.toLowerCase() === "boolean");
        let reqSerializacion = false;

        if (camposBoolean.length > 0 && data.data.length > 0) {

            console.log("data.data, ", data.data);
            let genSistema = data.data[0];
            camposBoolean.forEach(metadata => { reqSerializacion = reqSerializacion || typeof genSistema["uts"][metadata.campo] !== "boolean" });

            if (reqSerializacion) {
                data.data.forEach(genSistema => {
                    camposBoolean.forEach(metadata => { if (typeof genSistema["uts"][metadata.campo] !== "boolean") genSistema["uts"][metadata.campo] = genSistema["uts"][metadata.campo].toLowerCase() === "true" });
                });
            }

        }

        return response.data;
    }


    async getGenericasSistemaDS(tg, params, idEmpresa, idioma, userName, filtroUts, clasificadorOperacionTg) {

        if (clasificadorOperacionTg == undefined) {
            clasificadorOperacionTg = "";
        }
        //console.log("getGenericasSistema1", {tg, params, idEmpresa, idioma, userName, tokenAuth});

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        let bodyContentPayload = { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts, 'clasificadorOperacionTg': clasificadorOperacionTg };
        let contentPayload = JSON.stringify(bodyContentPayload);
        let hash = crypto.SHA512(contentPayload + userName + userName).toString()

        let contentPayloadEncoded = Buffer.from(contentPayload).toString('base64');

        //Buffer.from(str, 'base64') andbuf.toString('base64')

        let payload = {
            contentPayload: contentPayloadEncoded, hash: hash, bodyContentPayload: bodyContentPayload
        }

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'filtroUts': filtroUts }),
            payload: payload
        };

        /*
  
para las url externas, hay que manejar los queryparams como base64 con hash
crypto.SHA512(plain_text).toString()

var encodedStringBtoA = btoa(decodedStringBtoA);
var decodedStringAtoB = atob(encodedStringAtoB);

*/


        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllGenericasSistemaDS?' + queryParams, requestOptions.payload);

        const data = response.data;
        let camposDate = data.metadata.filter(x => x.tipoDato.toLowerCase() === "date");

        if (camposDate.length > 0) {
            data.data.forEach(genSistema => {
                camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
            });
        }

        let candidatosBoolen = data.metadata.filter(x => x.tipoDato.toLowerCase() === "boolean");
        let camposBoolean = [];
        let reqSerializacion = false;

        candidatosBoolen.forEach(x => {

            let genCan = data.data.find(d => d.tg === x.tg);
            if (genCan !== undefined && typeof genCan["uts"][x.campo] !== "boolean") {
                camposBoolean.push({ ...x });
                reqSerializacion = true;
            }

        });

        if (camposBoolean.length > 0 && data.data.length > 0) {

            //let genSistema = data.data[0];
            /*camposBoolean.forEach(metadata => {

                reqSerializacion = reqSerializacion || typeof genSistema["uts"][metadata.campo] !== "boolean"
            });*/

            if (reqSerializacion) {

                let tgs = Object.groupBy(camposBoolean, cam => cam.tg);
                console.log("tgs, ", tgs);

                data.data.forEach(genSistema => {
                    camposBoolean.forEach(metadata => {
                        if (typeof genSistema["uts"][metadata.campo] !== "boolean")
                            genSistema["uts"][metadata.campo] = genSistema["uts"][metadata.campo].toLowerCase() === "true"
                    });
                });
            }

        }

        return response.data;
    }

    async GetAllGenericasSistemaDependiente(tg, tgRef, referenciaRef, params, idEmpresa, idioma, userName, filtroUts, filtroExterno) {

        //console.log("getGenericasSistema1", {tg, params, idEmpresa, idioma, userName, tokenAuth});

        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'tgRef': tgRef, 'referenciaRef': referenciaRef, 'filtroUts': filtroUts, 'filtroExterno': filtroExterno })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetAllGenericasSistemaDependiente?' + queryParams, requestOptions.body);

        const data = response.data;
        let camposDate = data.metadata.filter(x => x.tipoDato.toLowerCase() === "date");

        if (camposDate.length > 0) {
            data.data.forEach(genSistema => {
                camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
            });
        }

        let camposBoolean = data.metadata.filter(x => x.tipoDato.toLowerCase() === "boolean");
        let reqSerializacion = false;

        if (camposBoolean.length > 0 && data.data.length > 0) {

            let genSistema = data.data[0];
            camposBoolean.forEach(metadata => { reqSerializacion = reqSerializacion || typeof genSistema["uts"][metadata.campo] !== "boolean" });

            if (reqSerializacion) {
                data.data.forEach(genSistema => {
                    camposBoolean.forEach(metadata => { if (typeof genSistema["uts"][metadata.campo] !== "boolean") genSistema["uts"][metadata.campo] = genSistema["uts"][metadata.campo].toLowerCase() === "true" });
                });
            }

        }

        return response.data;
    }

    async getGenericaSistemaById(idEmpresa, idioma, userName, tg, idSearch) {

        //console.log("getGenericasSistema1", {tg, params, idEmpresa, idioma, userName, tokenAuth});

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tg': tg, 'idSearch': idSearch })
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/GetGenericaSistemaById?', requestOptions.body);

        const data = response.data;
        let camposDate = data.metadata.filter(x => x.tipoDato.toLowerCase() === "date");

        if (camposDate.length > 0) {
            camposDate.forEach(metadata => { data.data["uts"][metadata.campo] = new Date(data.data["uts"][metadata.campo]); });
        }

        let camposBoolean = data.metadata.filter(x => x.tipoDato.toLowerCase() === "boolean");
        let reqSerializacion = false;

        if (camposBoolean.length > 0 && data.data.length > 0) {

            camposBoolean.forEach(metadata => { reqSerializacion = reqSerializacion || typeof data.data["uts"][metadata.campo] !== "boolean" });

            if (reqSerializacion) {
                camposBoolean.forEach(metadata => { if (typeof data.data["uts"][metadata.campo] !== "boolean") data["uts"][metadata.campo] = data.data["uts"][metadata.campo].toLowerCase() === "true" });
            }

        }

        return response.data;
    }

    async saveGenericaSistema(idEmpresa, idioma, userName, genericaSistema, children) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        let genericaStr = JSON.stringify(genericaSistema);
        console.log("genericaStr, ", genericaStr, genericaSistema);

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'genericaSistema': genericaSistema, 'genericaSistema2': JSON.stringify(genericaSistema), 'genericasDependientes': JSON.stringify(children) }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/saveGenericaSistema', requestOptions.body);

        const data = response.data;

        if (data.genericasSistemaAffected.length > 0) {
            let camposDate = data.metadataAffected.filter(x => x.tipoDato.toLowerCase() === "date");

            if (camposDate.length > 0) {
                data.genericasSistemaAffected.forEach(genSistema => {
                    camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
                });
            }
        }

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async sendEmail(idEmpresa, idioma, userName, genericaSistema) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'genericaSistema': genericaSistema, 'genericaSistema2': JSON.stringify(genericaSistema) }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/sendEmail', requestOptions.body);

        const data = response.data;

        if (data.genericasSistemaAffected.length > 0) {
            let camposDate = data.metadataAffected.filter(x => x.tipoDato.toLowerCase() === "date");

            if (camposDate.length > 0) {
                data.genericasSistemaAffected.forEach(genSistema => {
                    camposDate.forEach(metadata => { genSistema["uts"][metadata.campo] = new Date(genSistema["uts"][metadata.campo]); });
                });
            }
        }

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }


    async removeGenericaSistema(idEmpresa, idioma, userName, genericaSistema) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'genericaSistema': genericaSistema, 'genericaSistema2': JSON.stringify(genericaSistema) }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/removeGenericaSistema', requestOptions.body);

        let aaa = response.data;

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }


    async RemoveGenericaSistema(idEmpresa, idioma, userName, genericaSistema) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'genericaSistema': genericaSistema, 'genericaSistema2': JSON.stringify(genericaSistema) }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/RemoveGenericaSistema', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async savefileUpload(idEmpresa, idioma, userName, guidDocumento, tgRef, cgRef, file) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            //body:  { 'idEmpresa': idEmpresa, 'idioma':idioma, 'userName':userName, 'genericaSistema':genericaSistema, 'genericaSistema2': JSON.stringify(genericaSistema) } 
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'tgRef': tgRef, 'cgRef': cgRef, 'guidDocumento': guidDocumento }
        };

        const data11 = new FormData();
        data11.append('file', file);
        data11.append('modelo', JSON.stringify(requestOptions.body));

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/saveDocument', data11);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async getDocumentByGuid(idEmpresa, idioma, userName, guid) {

        let res = false;

        let filename = "";
        const authStorage = new AuthStorage(window.location.pathname);
        const userDetails = authStorage.GetCurrentUser();
        const { token } = userDetails;

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token, 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': 'Content-Disposition' },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'guidDocumento': guid })
        };

        await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/getDocumentByGuid', requestOptions).then((result) => {
            if (!result.ok) {
                throw Error(result.statusText);
            }

            // We are reading the *Content-Disposition* header for getting the original filename given from the server
            const header = result.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1].replaceAll("\"", "");

            filename = decodeURI(filename);


            return result.blob();
        })
            .then(async (blob) => {

                console.log("Entró acá");

                if (blob != null) {
                    await saveAs(blob, filename);
                    res = true;
                    window.close();

                }

                else if (blob != null) {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    res = true;
                    window.close();
                }
            })
            .catch((err) => {
                console.log(err);
            });

        return res;
    }

    async getFile(idEmpresa, idioma, userName, ruta) {

        let filename = "";
        const authStorage = new AuthStorage(window.location.pathname);
        const userDetails = authStorage.GetCurrentUser();
        const { token } = userDetails;

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token, 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': 'Content-Disposition' },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'urlAsset': ruta })
        };

        const queryParams ="lazyEvent="+encodeURIComponent(ruta) ;//params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        

        let res = await fetch(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/getFile?'+queryParams, requestOptions).then((result) => {
            if (!result.ok) {
                throw Error(result.statusText);
            }

            // We are reading the *Content-Disposition* header for getting the original filename given from the server
            const header = result.headers.get('Content-Disposition');
            const parts = header.split(';');
            filename = parts[1].split('=')[1].replaceAll("\"", "");

            filename = decodeURI(filename);


            return result.blob();
        }).then(async (blob) => {

            console.log("Entró acá");

            if (blob != null) {
                var url = window.URL.createObjectURL(blob);
                return url;

            }
        }).catch((err) => {
            console.log(err);
        });

        return res

    }

    getURLFile(idEmpresa, idioma, userName, ruta) {

        let filename = "";
        const authStorage = new AuthStorage(window.location.pathname);
        const userDetails = authStorage.GetCurrentUser();
        const { token } = userDetails;

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Authorization': "Bearer " + token, 'Access-Control-Allow-Origin': '*', 'Access-Control-Expose-Headers': 'Content-Disposition' },
            body: JSON.stringify({ 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'urlAsset': ruta })
        };

        const queryParams ="lazyEvent="+encodeURIComponent(ruta) ;//params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        

        let res  = process.env.NEXT_PUBLIC_URL_API + 'api/v1/Auth/getFile?'+queryParams;

        return res

    }

    async decryptString(idEmpresa, idioma, userName, textEncrypted) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'queryParams': textEncrypted }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/decryptString', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async decodeToken(idEmpresa, idioma, userName, token) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName, 'queryParams': token }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/decodeToken', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

    async getIdTercero(idEmpresa, idioma, userName) {

        //const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';

        const requestOptions = {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*', 'Authorization': "Bearer " },
            body: { 'idEmpresa': idEmpresa, 'idioma': idioma, 'userName': userName }
        };

        const response = await axios.post(process.env.NEXT_PUBLIC_URL_API + 'api/v1/GenericaSistema/getIdTercero', requestOptions.body);

        return response.data;

        //return await fetch(process.env.NEXT_PUBLIC_URL_API+'api/v1/OrdenTrabajo/GetAllTipoGenericaSistema',requestOptions).then(res => res.json());

    }

}